// utils
import Screen from '../index';
import { getImoveisListServerSideProps } from '../../../lib/server/site-props';

export const getServerSideProps = getImoveisListServerSideProps;

const Model = () => {
    return <Screen/>;
};

export default Model;
